import FormModel from './formModel';

const {
    formField: {
        name,
        lastName,
        email,
        phone,
        codLocalidad,
        dni,
        tipoSeguro,
        idProducto,
        comentario,
    }
} = FormModel;


export default {
    [name.name]: '',
    [lastName.name]: '',
    [email.name]: '',
    [phone.name]: '',
    [dni.name]: '',
    [codLocalidad.name]: '',
    [tipoSeguro.name]: '',
    [idProducto.name]: '',
    [comentario.name]: '',
    archivos: []
};
